export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string
if (!CLERK_PUBLISHABLE_KEY) console.warn('VITE_CLERK_PUBLISHABLE_KEY is not set — sign-in will not work')
